import { useQuery } from '@tanstack/react-query';

import { Visitor } from 'src/features/visitor/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/visitors/visitor/:visitorId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    visitorId: string;
}
const queryFn = ({ parkingId, visitorId, ...params }: DTO): Promise<Visitor> => {
    return axios.get(formatResourcePath(RESOURCE, { visitorId, parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetVisitor };
